import { render } from "./OfficeListModal.vue?vue&type=template&id=87f10f9a&scoped=true"
import script from "./OfficeListModal.vue?vue&type=script&lang=js"
export * from "./OfficeListModal.vue?vue&type=script&lang=js"

import "./OfficeListModal.vue?vue&type=style&index=0&id=87f10f9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87f10f9a"

export default script